module.exports = __webpack_public_path__ + "img/1513640702.65e7b9c1.jpg";